export const BehaviourType = {
  Query: "query",
  Hash: "hash",
} as const;
